import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pointer-events-auto w-full max-w-md overflow-hidden rounded-lg bg-white ring-1 shadow-lg ring-black/5 fixed bottom-4 right-4 z-50"
}
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_5 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_6 = { class: "mt-2 text-sm text-gray-600 leading-relaxed" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "list-disc list-inside space-y-1 text-xs text-gray-500" }
const _hoisted_9 = { class: "flex items-center gap-1" }
const _hoisted_10 = { class: "inline-flex items-center gap-1" }
const _hoisted_11 = { class: "px-1.5 py-0.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-md" }
const _hoisted_12 = { class: "ml-4 flex shrink-0" }
const _hoisted_13 = { class: "sr-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transform ease-out duration-300 transition",
    "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
    "leave-active-class": "transition ease-in duration-100",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: _withCtx(() => [
      (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "shrink-0" }, [
                  _createElementVNode("svg", {
                    class: "h-6 w-6 text-blue-400",
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                      "clip-rule": "evenodd"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('notifications.new_feature.toast_title')), 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('notifications.new_feature.description')), 1),
                    _createElementVNode("ul", _hoisted_8, [
                      _createElementVNode("li", null, _toDisplayString(_ctx.$t('notifications.new_feature.feature_1')), 1),
                      _createElementVNode("li", null, _toDisplayString(_ctx.$t('notifications.new_feature.feature_2')), 1),
                      _createElementVNode("li", _hoisted_9, [
                        _createTextVNode(_toDisplayString(_ctx.isMac ? _ctx.$t('notifications.new_feature.feature_3_mac') : _ctx.$t('notifications.new_feature.feature_3_other')) + " ", 1),
                        _createElementVNode("span", _hoisted_10, [
                          _createElementVNode("kbd", _hoisted_11, _toDisplayString(_ctx.isMac ? '⌘' : 'Ctrl'), 1),
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-gray-400" }, "+", -1)),
                          _cache[2] || (_cache[2] = _createElementVNode("kbd", { class: "px-1.5 py-0.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-md" }, " A ", -1))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
                    class: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                  }, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('common.close')), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("svg", {
                      class: "h-5 w-5",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}